class PopIn {
  constructor () {
    let popName = 'cookie_pop_newsletter';
    if (!checkCookie(popName)) {
      let popin = document.getElementById('block-newsletterpopinblock');
      let container = document.querySelector('.layout-container');
      if (popin && popin.querySelector('.icon-close')) {
        if (checkCookie(popName)) {
          popin.style.display = 'none';
        } else {
          popin.style.display = 'block';
          container.classList.add('pop');
        }
        popin.querySelector('.icon-close').addEventListener('click', function (e) {
          container.classList.remove('pop')
          popin.style.display = 'none'
          setCookie(popName, 'hide', 396)
        })
      }
    }
  }
}

function setCookie (cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie (cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie (cname) {
  let cookie = getCookie(cname)
  if (cookie !== '') {
    return true
  } else {
    return false
  }
}

export default PopIn
